import React from 'react';
import WisywigForm from './WysiwygForm';
import {
  number,
  merge,
} from '@its/util';
import {
  sortByRowNum,
  getDisplayMaps,
  frameIteration,
  frameButton,
  frameId,
} from './util';
import {
  developer,
  admin,
} from '@its/components/lib/Container components/UserContainer/roles';
import {
  UserPermissionContainer,
} from '@its/components/lib/Container components/UserContainer/UserPermissionContainer';

const getWisywigField = (currentRow, pluginList, displayMap, displayTemplateMap) => {
  const fields = {};
  const initialValues = {};
  let newLine = false;
  if (currentRow !== displayTemplateMap.rowNum) {
    newLine = true;
    currentRow = displayTemplateMap.rowNum;
  }
  const isIndicator = displayTemplateMap.specialFeatures - 8 >= 0;
  fields[`_${displayMap.frame}_${displayMap.id}`] = {
    maxLength: displayTemplateMap.width,
    type: 'select',
    items: pluginList,
    newLine,
    labelStyle: { color: isIndicator ? '#FFFFFF' : displayTemplateMap.color },
    underlineStyle: {
      borderColor: 'rgba(255, 255, 255, 0)',
    },
    underlineFocusStyle: {
      borderColor: 'rgba(255, 255, 255, 0)',
    },
    style: {
      margin: '10px 8px',
      fontWeight: '600',
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
    },
  };
  initialValues[`_${displayMap.frame}_${displayMap.id}`] = displayMap.source || -1;
  return {
    fields,
    initialValues,
    currentRow,
  };
};

export default class extends React.Component {

  constructor(props, context) {
    super(props, context);

    this.getWysiwyg = (displayMaps, displayTemplateMaps, pluginList) => {
      const fields = [];
      let initialValues = {};
      const currentRow = [];
      displayTemplateMaps.sort(sortByRowNum);
      pluginList = [{
        primaryText: 'Static',
        value: -1,
      }, ...pluginList];
      for (const displayTemplateMap of displayTemplateMaps) {
        const displayMapFrames = getDisplayMaps(
          displayMaps,
          displayTemplateMap.id,
        );
        for (let i = 0; i < displayMapFrames.length; i++) {
          if (!fields[displayMapFrames[i].frame]) {
            fields[displayMapFrames[i].frame] = { fields: {} };
          }
          if (!currentRow[displayMapFrames[i].frame]) {
            currentRow[displayMapFrames[i].frame] = 1;
          }
          const wysiwygField = getWisywigField(currentRow[displayMapFrames[i].frame], pluginList, displayMapFrames[i], displayTemplateMap);
          fields[displayMapFrames[i].frame].fields = merge(fields[displayMapFrames[i].frame].fields, wysiwygField.fields);
          initialValues = merge(initialValues, wysiwygField.initialValues);
          currentRow[displayMapFrames[i].frame] = wysiwygField.currentRow;
        }
      }
      return {
        fields,
        initialValues,
      };
    };

    this.onSubmit = (display, values) => {
      let result = Object.assign({}, display);
      result.displayMaps = [...display.displayMaps];
      result.displayFramesIteration = [...display.displayFramesIteration];
      for (let prop in values) {
        if (frameIteration.test(prop)) {
          const frame = prop.split('_')[1];
          for (const displayFrameIteration of result.displayFramesIteration) {
            if (displayFrameIteration.frame == frame) {
              displayFrameIteration.iterationId = values[prop];
            }
          }
          delete values[prop];
        } else if (frameButton.test(prop) || frameId.test(prop)) {
          delete values[prop];
        } else {
          prop = prop.split('_');
          if (prop[1] && prop[2] && number.test(prop[1]) && number.test(prop[2])) {
            for (const displayMap of result.displayMaps) {
              if (displayMap.frame == prop[1] && displayMap.id == prop[2]) {
                if (values[`_${prop[1]}_${prop[2]}`] !== -1) {
                  displayMap.source = values[`_${prop[1]}_${prop[2]}`];
                  displayMap.sourceType = 2;
                } else {
                  displayMap.source = null;
                  displayMap.sourceType = 1;
                }
                delete values[`_${prop[1]}_${prop[2]}`];
              }
            }
          }
        }
      }
      result = Object.assign({}, display, values);
      if (values.templateId != display.templateId) {
        delete result.displayMaps;
      }
      return result;
    };
  }

  render() {
    return (
      <UserPermissionContainer
        allowedRoles={[developer, admin]}
        showError
      >
        <WisywigForm
          name="configureDisplay"
          getWysiwyg={this.getWysiwyg}
          onSubmit={this.onSubmit}
        />
      </UserPermissionContainer>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/routes/Display/DisplayConfiguration.js
 **/